import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import whiteBackground from '../wrapper-components/white-background';
import { fetchBooking } from '../app-main/actions/booking';
import _ from 'lodash';
import { Spinner } from 'shared-components/decorators/spinner';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class AttendeeSetupRouterMain extends React.Component {
  constructor (props) {
    super(props);

    this.redirectTo = this.redirectTo.bind(this);
  }

  componentDidMount () {
    const publicBookingId = _.get(this.props, 'routeParams.publicBookingId');
    const { dispatch, accessToken } = this.props;
    dispatch(fetchBooking(publicBookingId, accessToken));
  }

  shouldComponentUpdate (nextProps) {
    const shouldUpdateIfBookingIdExists = !!_.get(nextProps, 'booking.booking._id');

    return shouldUpdateIfBookingIdExists;
  }

  componentDidUpdate () {
    const bookingId = _.get(this.props, 'booking.booking._id');
    const publicBookingId = _.get(this.props, 'booking.booking.pid');
    const userSsoId = _.get(this.props, 'profile.SSOid');
    const guestSsoId = _.get(this.props, 'booking.booking.guest.ssoid');
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();

    if (userSsoId !== guestSsoId) {
      this.redirectTo(`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}`);
      return true;
    }

    if (!_.get(this.props, 'booking.booking.public_fields.guest_title')) {
      this.redirectTo(`/invite/add/${bookingId}`);
      return true;
    }

    // temp fix that allows users to user the back button from /invite to /inbox
    const previousPathname = _.get(this.props, 'previousLocation.pathname');
    if (`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}` === previousPathname ||
        `/invite/add/${bookingId}` === previousPathname
    ) {
      this.redirectTo(`/inbox/${bookingId}`);
      return true;
    }

    this.redirectTo(`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}`);
    return true;
  }

  redirectTo (path) {
    this.props.dispatch(push(path));
  }

  render () {
    return (
      <div className="AttendeeSetupRouterMain style-2 remove-bootstrap flex center">
        <div className="content-container flex center">
          <Spinner additionalStyle="gray large" />
        </div>
      </div>
    );
  }
}

AttendeeSetupRouterMain.propTypes = {
  dispatch: PropTypes.func,
  accessToken: PropTypes.string
};

function mapStateToProps (state) {
  const { auth, booking, profile } = state;
  const { accessToken } = auth;

  return {
    accessToken,
    profile,
    booking
  };
}

export default connect(mapStateToProps)(whiteBackground(AttendeeSetupRouterMain));
